import { Component, OnInit } from '@angular/core';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi, ColDef, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridReadyEvent, Column, PaginationChangedEvent, RowClickedEvent, ICellRendererParams } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { TransactionMasterService } from '../fraud-prevention/transaction-master-rule/transaction-master-service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { BtnCellRenderer2 } from 'src/app/common/button-cell-renderer2.component';
import Swal from 'sweetalert2';
import { DeveloperService } from './developer-service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const { defaultPageSizeArr, defaultPageSize } = environment;
export interface Filter {
  "pageRecords"?: number;
  "pageNumber"?: number;
  "dateFrom"?: string;
  "dateTo"?: string;
  "status"?: string;
  "processedBy"?: string;
  "senderId"?: string;
}
@Component({
  selector: 'app-developer-report',
  templateUrl: './developer-report.component.html',
  styleUrls: ['./developer-report.component.scss']
})
export class DeveloperReportComponent implements OnInit {

  currentDate: any = new Date();
      private gridApi!: GridApi;
      private gridColumnApi!: ColumnApi;
      public rowData: any = [];
      globalSearch: string = '';
      public defaultColDef: ColDef = {
        flex: 1,
        minWidth: 200,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeight: true
      };
      collectionSize: number = 0;
      pageRecords: number = defaultPageSize;
      pageSizeArr: any = defaultPageSizeArr;
      pageNumber: number = 1;
      isQuickFilter: boolean = false;
      accountData: any = [];
      settlementData: any = [];
      collectiondata: number = 0;
      totalRecords: any;
      status: any;
      processedBy: any;
      public searchFromDate: NgbDateStruct;
      public searchToDate: NgbDateStruct;
      minDate: NgbDateStruct;
      maxDate: NgbDateStruct;
      maxDateFrom: NgbDateStruct;
      emailId: any;
      customerId:any;
      transactionId:any;

      public columnDefs: ColDef[] = [
        {
          field: 'fullName',
          lockVisible: true,
          headerName: 'Full Name',
        },
        {
          field: 'workEmail',
          lockVisible: true,
          headerName: 'Work Email',
        },
        {
          field: 'companyName',
          lockVisible: true,
          headerName: 'Company Name',
        },
        {
          field: 'role',
          lockVisible: true,
          headerName: 'Role',
        },
         {
          field: 'emailVerification',
          lockVisible: true,
          headerName: 'Email Verification',
          cellRenderer: (params: any) => {
            const verify = params.value; // Ensure case-insensitive comparison
            let badgeClass = '';
            let statusText = '';
            console.log(verify)
            if(verify){
              badgeClass = 'badge-success';
              statusText = 'Verified';
            }else{
              badgeClass = 'badge-warning';
              statusText = 'Pending';
            }
            return `<span class="badge ${badgeClass}">${statusText}</span>`;
          }
        },
        {
          field: 'createDate',
          lockVisible: true,
          headerName: 'Created On'
        },
         {
          field: 'updateDate',
          lockVisible: true,
          headerName: 'Updated On'
        },
         {
          field: 'updatedBy',
          lockVisible: true,
          headerName: 'Updated By'
        },
         {
          field: 'status',
          lockVisible: true,
          headerName: 'Status',
          cellRenderer: (params: any) => {
            const status = params.value; // Ensure case-insensitive comparison
            let badgeClass = '';
            let statusText = '';

            // Define badge class and status text based on status
            switch (status) {
              case 'ACTIVE':
                badgeClass = 'badge-success';
                statusText = 'Active';
                break;
              case 'REJECTED':
                badgeClass = 'badge-danger';
                statusText = 'Rejected';
                break;
              case 'PENDING':
                badgeClass = 'badge-warning';
                statusText = 'Pending';
                break;
              case 'BLOCKED':
                badgeClass = 'badge-info';
                statusText = 'Blocked';
                break;

              default:
                badgeClass = '';
                statusText = '';
                break;
            }

            return `<span class="badge ${badgeClass}">${statusText}</span>`;
          }

        },
         {
              field: 'actions',
              lockVisible: true,
              headerName: 'Actions',
              width: 60,
              cellRenderer: BtnCellRenderer2,
              cellRendererParams: [ 
                {
                  clicked: async (event: any, param: any) => {
                    this.emailId = param.data.workEmail;
                    this.openApprovalSwal('approve');
                  },
                  buttonIconClass: 'icon-check',
                  isButtonVisible: (params: ICellRendererParams) => {
                    const data = params.data;
                    return data && (data.status === 'PENDING' || data.status === 'Pending') && data.emailVerification;
                  },
                  buttonClass: 'custom-button-class-black-background'
                },
                {
                  clicked: async (event: any, param: any) => {
                    this.emailId = param.data.workEmail;
                    this.openApprovalSwal('reject');
                  },
                  buttonIconClass: 'icon-x',
                  isButtonVisible: (params: ICellRendererParams) => {
                    const data = params.data;
                    return data && (data.status === 'PENDING' || data.status === 'Pending') && data.emailVerification;
                  },
                  buttonClass: 'custom-button-class-black-background'
                },
              ],
            }
      ];
  
      Resultdata: any;
      merchant: any;
      constructor(private alertService: AlertService, private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter,private developerService : DeveloperService) {
        this.maxDateFrom = this.ngbCalender.getToday();
        this.maxDate = this.ngbCalender.getToday();
      }
    
      ngOnInit(): void {
        this.getDeveloperReport();
      }
  
    
      getDeveloperReport() {
        const filter: Filter = {}
        if (this.ngbDateParserFormatter.format(this.searchFromDate) == "" || this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00") {
          filter.dateFrom = "";
        } else {
          filter.dateFrom = this.ngbDateParserFormatter.format(this.searchFromDate);
        }
     
        if (this.ngbDateParserFormatter.format(this.searchToDate) == "" || this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00") {
          filter.dateTo = "";
        } else {
          filter.dateTo = this.ngbDateParserFormatter.format(this.searchToDate);
        }
     
        this.developerService.getDeveloperReport(this.pageNumber - 1, this.pageRecords, filter.dateFrom, filter.dateTo, this.customerId,this.transactionId).subscribe((data: any) => {
          console.log(data.response.data.content);
          this.rowData = data.response.data.content;
          this.rowData = data.response.data.content;
          this.collectiondata = data.response.data.content
          this.collectionSize = data.response.data.totalElements
          this.totalRecords = data.response.data.totalElements
          if (data.response.data.content.length == 0) {
            console.log("No data");
            this.alertService.errorAlertWithMessage("No records present");
          }
        })
      }

      async openApprovalSwal(status:any){
        await Swal.fire({
                title: "Are you sure ?",
                text: "You want to "+status+" this developer account",
                confirmButtonText: '<span id="confirm-button-text">Yes</span>',
                showCancelButton: true,
                reverseButtons: false,
                confirmButtonColor: '#e61c1c',
                cancelButtonColor: '#7987a1',
                customClass: {
                  confirmButton: 'swal2-confirm-custom',
                  cancelButton: 'swal2-cancel-custom'
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  let finalStatus = "";
                  if(status == "approve"){
                    finalStatus = "ACTIVE";
                  }else if(status == "reject"){
                    finalStatus = "REJECTED";
                  }
                  this.developerService.updateDeveloper(this.emailId,finalStatus).subscribe((response:any)=>{
                  console.log(response);
                  if(response.response.httpStatus == "OK"){
                    Swal.fire(response.response.message,'','success');
                    this.getDeveloperReport();
                    return;
                  }else{
                    Swal.fire(response.response.message,'','error');
                    this.getDeveloperReport();
                    return;
                  }
                  })
                }
                });
      }
    
      onFilterChange(param: FilterChangedEvent | any) {
    
      }
    
      onSortChange(event: any) {
        // console.log("==Sort===>", event);
      }
    
      onFilterModified(param: FilterModifiedEvent | any) {
      }
    
      onFilterOpened(param: FilterOpenedEvent | any) {
        // console.log("onFilterOpened----->", param);
      }
    
    
      onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        const allColumnIds: (string | Column)[] = [];
        params?.columnApi?.getColumns()?.forEach((column) => {
          allColumnIds.push(column.getId());
        });
        params?.columnApi?.autoSizeColumns(allColumnIds, false);
      }
    
      onPageSizeChanges(eve: any) {
        this.pageNumber = 1;
        this.getDeveloperReport();
      }
    
      onPaginationChange(param: PaginationChangedEvent | any) {
        this.pageNumber = param;
        this.getDeveloperReport();
      }
    
    
    
      private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
      }
    
      public exportAsExcelFile(): void {
        const excelFileName: string = 'developer _report';
        this.getDeveloperReport();
        let tempRec: any = [];
        tempRec = this.columnDefs.filter((col: any) => {
          const column: any = this.gridColumnApi.getColumn(col?.field);
          return column.visible && !(col?.field == "actions")
        });
        let keysToMatch: any = [];
        tempRec.map((col: any) => keysToMatch.push(col.field));
        let jsonData = this.findMatchingObjects(keysToMatch);
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
          header: [...tempRec.map((col: any) => col.headerName)]
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
        XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: 'A2', skipHeader: true });
        XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
        const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
      }
    
      findMatchingObjects(keys: string[]): any[] {
        let expData: any = [];
        this.rowData.forEach((curr: any) => {
          const tempRec: any = {}
          keys.forEach((col) => {
            const column: any = this.gridColumnApi.getColumn(col);
            if (column.visible) {
              tempRec[col] = curr[col];
            }
          })
          expData.push(tempRec);
        })
        return expData;
      }
    
      onRowClicked(param: RowClickedEvent | any) {
        // console.log("Row Clicked", param);
      }
    
      onRowDoubleClicked(param: RowClickedEvent | any) {
        // console.log("Row Double Clicked", param);
      }
    
      changeDate() {
        this.currentDate = this.searchFromDate
        this.minDate = this.searchFromDate;
        let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
      }
     
      changeEndDate() {
        this.currentDate = this.searchToDate;
        this.maxDateFrom = this.searchToDate;
      }
    
      resetFilter(): void {
        this.customerId = "";
        this.transactionId = "";
        this.searchFromDate = {year: 0,month: 0,day: 0,};
        this.searchToDate = {year: 0,month: 0,day: 0,};
      }

}
